import Vue from 'vue'

export default new Vue({
    data() {
        return {
            //loginSuccess: false
        }
    },
    created() {
        /* 暫時保留寫法，供以後參考
        this.$on('EVENT_LOGIN_SUCCESS', function(msg) {
            if(msg === true) {
                this.loginSuccess = new Date().getTime();
            }
        })
        */
    },
});